const initialState = {
    selectedDropOff: null,
    // other state properties...
  };
  
  const selectedDropOff = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_SELECTED_DROPOFF':
        return {
          ...state,
          selectedDropOff: action.payload,
        };
      // handle other actions...
      default:
        return state;
    }
  };
  
  export default selectedDropOff;
  